export default __webpack_public_path__ + "static/media/sharing.d86bf745.svg";